import { render, staticRenderFns } from "./own-space.vue?vue&type=template&id=c51e3430&"
import script from "./own-space.vue?vue&type=script&lang=js&"
export * from "./own-space.vue?vue&type=script&lang=js&"
import style0 from "./own-space.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports